import {
    isLegalSectionActive,
    isVerifyIdentitySectionActive,
  } from "@/lib/util";
  import { RootState } from "@/store/dtm";
  import clsx from "clsx";
  import { useSelector } from "react-redux";
  import { useLocation } from "react-router-dom";
  
  export default function IDVerificationTracker() {
    const verifyIdentitySectionComplete = useSelector(
      (state: RootState) => state.progress.progress.verifyIdentity
    );
  
    const legalTermsSectionComplete = useSelector(
      (state: RootState) => state.progress.progress.legal
    );
  
    const pathname = useLocation().pathname.toLowerCase();
  
    const verifyIdentitySectionActive = isVerifyIdentitySectionActive(pathname);
    const legalTermsSectionActive = isLegalSectionActive(pathname);
  
  
    return (
      <>
        <div>
          <div>
            <nav
              className="hs-accordion-group sm:p-6 w-full flex flex-col flex-wrap mt-10"
              data-hs-accordion-always-open
            >
              <ul className="space-y-1.5">
                <li className={clsx(verifyIdentitySectionActive ? "tracker-active-light" : "")}>
                  <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{paddingLeft: 8}}>
                    <div
                      className={clsx(
                        "tracker",
                        verifyIdentitySectionActive ? "tracker-active" : "",
                        verifyIdentitySectionComplete ? "tracker-complete" : ""
                      )}
                    >
                      <span
                        className={clsx(
                          "step-count",
                          verifyIdentitySectionActive ? "active" : "",
                          verifyIdentitySectionComplete ? "hidden" : ""
                        )}
                      >
                        1
                      </span>
                      <span
                        className={clsx(verifyIdentitySectionComplete ? "" : "hidden")}
                      >
                        <img
                          src="assets/task-finished-icon.svg"
                          alt="section complete"
                          className="mt-2 ml-1.5"
                          width={11}
                          height={8}
                        />
                      </span>
                    </div>
                    <p
                      className={clsx(
                        verifyIdentitySectionActive ? "active" : "",
                        verifyIdentitySectionComplete ? "complete" : ""
                      )}
                      style={{marginTop: 0, paddingTop: 4, paddingBottom: 4}}
                    >
                      Verify your identity
                    </p>
                  </div>
                </li>
                <li className={clsx(legalTermsSectionActive ? "tracker-active-light" : "")}>
                  <div className="flex items-center gap-x-3.5 text-sm text-slate-700 rounded-md" style={{paddingLeft: 8}}>
                    <div
                      className={clsx(
                        "tracker",
                        legalTermsSectionActive ? "tracker-active" : "",
                        legalTermsSectionComplete ? "tracker-complete" : ""
                      )}
                    >
                      <span
                        className={clsx(
                          "step-count",
                          legalTermsSectionActive ? "active" : "",
                          legalTermsSectionComplete ? "hidden" : ""
                        )}
                      >
                        2
                      </span>
                      <span
                        className={clsx(legalTermsSectionComplete ? "" : "hidden")}
                      >
                        <img
                          src="assets/task-finished-icon.svg"
                          alt="section complete"
                          className="mt-2 ml-1.5"
                          width={11}
                          height={8}
                        />
                      </span>
                    </div>
                    <p
                      className={clsx(
                        legalTermsSectionActive ? "active" : "",
                        legalTermsSectionComplete ? "complete" : ""
                      )}
                      style={{marginTop: 0, paddingTop: 4, paddingBottom: 4}}
                    >
                      Review legal terms
                    </p>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </>
    );
  }  